const setCountryApi = (params) => {
  const country = params?.country ?? process.env.NEXT_PUBLIC_JSW_GEOLOCATION;

  const apiEndpoint = "/api/job_seeker/v1/graphql";
  const baseURL =
    process.env.NEXT_PUBLIC_JSW_ENV === "prod"
      ? "https://"
      : "https://staging-";

  const domain = "-api.hiredly.com";

  let url;

  switch (country) {
    case "sg":
      url = baseURL + "sg" + domain + apiEndpoint;
      break;
    case "my":
      url = baseURL + "my" + domain + apiEndpoint;
      break;
    default:
      break;
  }

  return url;
};

const setEmployerParams = () => {
  const env = process.env.NEXT_PUBLIC_JSW_ENV;

  let urlAndEnvParams = new URLSearchParams(window.location.search);

  urlAndEnvParams.append(
    "country",
    process.env.NEXT_PUBLIC_JSW_GEOLOCATION ?? "my"
  );

  urlAndEnvParams.append("env", process.env.NEXT_PUBLIC_JSW_ENV ?? "staging");

  urlAndEnvParams.append("origin", "jobseeker");

  if (env == "dev") {
    return `https://dev-employer.hiredly.com/register/?${urlAndEnvParams}`;
  } else if (env == "staging") {
    return `https://staging-employer.hiredly.com/register/?${urlAndEnvParams}`;
  } else {
    return `https://employer.hiredly.com/register/?${urlAndEnvParams}`;
  }
};

export { setCountryApi, setEmployerParams };
